import { useEffect, useState } from "react";
import { useAppSelector } from "../hooks/useAppSelector";
import { getRootApi } from "meta/utils/getRootApi";
export const useChangeTabEventBroadcasting = () => {
    const current = useAppSelector((state) => state.root.activeTabKey);
    const [previous, setPrevious] = useState(current);
    useEffect(() => {
        if (previous !== current) {
            getRootApi().FrontendEvents.tabSwitch(previous, current);
        }
        setPrevious(current);
    }, [current]);
};
